import React, { useState } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';

import {

  Box,

  Typography,

  Paper,

  TextField,

  Button,

  Alert,

  CircularProgress,

  Grid,

  Card,

  CardContent,

  Stack,

  Stepper,

  Step,

  StepLabel,

  StepContent,

  List,

  ListItem,

  ListItemIcon,

  ListItemText,

  FormControlLabel,

  Checkbox,

  Divider,

  IconButton,

  Dialog,

  DialogTitle,

  DialogContent,

  DialogActions,

} from '@mui/material';

import {

  ArrowBack as ArrowBackIcon,

  PlayArrow as PlayArrowIcon,

  CheckCircle as CheckCircleIcon,

  Language as LanguageIcon,

  Speed as SpeedIcon,

  Accessibility as AccessibilityIcon,

  Info as InfoIcon,

  Settings as SettingsIcon,

  AddCircleOutline as AddCircleOutlineIcon,

} from '@mui/icons-material';

import { useAuth } from '../../contexts/AuthContext';

import { useTranslation } from 'react-i18next';

import api from '../../services/api';



const NuevoAnalisis = () => {

  const navigate = useNavigate();

  const location = useLocation();

  const { user } = useAuth();

  const { t } = useTranslation();



  const [url, setUrl] = useState(location.state?.url || '');

  const [loading, setLoading] = useState(false);

  const [loadingService, setLoadingService] = useState(true);

  const [error, setError] = useState('');

  const [activeStep, setActiveStep] = useState(0);

  const [analyserService, setAnalyserService] = useState(null);

  const [contactDialogOpen, setContactDialogOpen] = useState(false);

  const [analysisOptions, setAnalysisOptions] = useState({

    standard: 'WCAG2AA',

    includedImpacts: ['critical', 'serious', 'moderate', 'minor'],

    viewport: {

      width: 1920,

      height: 1080

    }

  });



  // Obtener servicio del Analizador al montar el componente

  React.useEffect(() => {

    const fetchAnalyserService = async () => {

      try {

        setLoadingService(true);

        const response = await api.get(`/servicios?user_id=${user.id}&all=true`);

        const services = response.data.data || response.data;



        // Buscar servicio de tipo Analyser activo

        const analyser = services.find(

          service => service.service_type === 'Analyser' && service.status === true

        );



        if (analyser) {

          setAnalyserService(analyser);

        } else {

          setAnalyserService(null);

          setError(t('No tienes una suscripción activa del Analizador. Por favor, contrata un plan primero.'));

        }

      } catch (error) {

        setError(t('Error al verificar tu suscripción del Analizador'));

      } finally {

        setLoadingService(false);

      }

    };



    if (user?.id) {

      fetchAnalyserService();

    }

  }, [user?.id, t]);



  const validateUrl = (urlString) => {

    try {

      const urlObj = new URL(urlString);

      return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';

    } catch {

      return false;

    }

  };



  const handleStartAnalysis = async () => {

    setError('');



    if (!analyserService) {

      setError(t('No tienes una suscripción activa del Analizador'));

      return;

    }



    if (!url) {

      setError(t('Por favor ingresa una URL'));

      return;

    }



    if (!validateUrl(url)) {

      setError(t('Por favor ingresa una URL válida (debe empezar con http:// o https://)'));

      return;

    }



    setLoading(true);

    setActiveStep(1);



    try {

      const response = await api.post('/trigger-accessibility-analysis', {

        url: url,

        customer_id: user.id,

        service_id: analyserService.service_id,

        options: analysisOptions

      });



      if (response.data.success) {

        setActiveStep(2);

        

        // Redirect to report detail after 2 seconds

        setTimeout(() => {

          const analysisSeq = response.data.data.analysis_seq;

          navigate(`/dashboard/analizador/${analysisSeq}`);

        }, 2000);

      } else {

        setError(response.data.error || t('Error al iniciar el análisis'));

        setActiveStep(0);

      }

    } catch (error) {

      setError(

        error.response?.data?.error || 

        t('Error al conectar con el servidor de análisis')

      );

      setActiveStep(0);

    } finally {

      setLoading(false);

    }

  };



  const steps = [

    {

      label: t('Configurar análisis'),

      icon: <SettingsIcon />,

    },

    {

      label: t('Analizando'),

      icon: <SpeedIcon />,

    },

    {

      label: t('Completado'),

      icon: <CheckCircleIcon />,

    },

  ];



  // Mostrar carga mientras se verifica la suscripción

  if (loadingService) {

    return (

      <Box>

        <Box 

          sx={{

            display: "flex",

            alignItems: "center",

            gap: 2,

            mb: 3,

            padding: { xs: "12px 16px", sm: "8px 16px", md: "12px 16px" },

          }}

        >

          <Button

            startIcon={<ArrowBackIcon />}

            onClick={() => navigate('/dashboard/analizador')}

            variant="text"

            sx={{ minWidth: "auto" }}

          >

            {t('Volver')}

          </Button>

          <Typography 

            variant="h4" 

            component="h1" 

            sx={{

              fontSize: { xs: "20px", sm: "18px", md: "16px", lg: "22px" },

              fontWeight: "medium",

            }}

          >

            {t('Nuevo Análisis de Accesibilidad')}

          </Typography>

        </Box>

        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">

          <CircularProgress />

        </Box>

      </Box>

    );

  }



  // Mostrar mensaje si no tiene suscripción activa

  if (!analyserService) {

    return (

      <Box>

        <Box 

          sx={{

            display: "flex",

            alignItems: "center",

            gap: 2,

            mb: 3,

            padding: { xs: "12px 16px", sm: "8px 16px", md: "12px 16px" },

          }}

        >

          <Button

            startIcon={<ArrowBackIcon />}

            onClick={() => navigate('/dashboard/analizador')}

            variant="text"

            sx={{ minWidth: "auto" }}

          >

            {t('Volver')}

          </Button>

          <Typography 

            variant="h4" 

            component="h1" 

            sx={{

              fontSize: { xs: "20px", sm: "18px", md: "16px", lg: "22px" },

              fontWeight: "medium",

            }}

          >

            {t('Nuevo Análisis de Accesibilidad')}

          </Typography>

        </Box>

        <Paper elevation={1} sx={{ p: 4, textAlign: 'center' }}>

          <Alert severity="warning" sx={{ mb: 3 }}>

            <Typography variant="h6" gutterBottom>

              {t('Suscripción Requerida')}

            </Typography>

            <Typography variant="body2">

              {t('No tienes una suscripción activa del Analizador. Para realizar análisis de accesibilidad, necesitas contratar un plan.')}

            </Typography>

          </Alert>

          <Button

            variant="contained"

            onClick={() => setContactDialogOpen(true)}

            sx={{

              backgroundColor: '#0F52BD',

              '&:hover': { backgroundColor: '#0a3d8f' }

            }}

          >

            {t('Ver Planes del Analizador')}

          </Button>

        </Paper>

      </Box>

    );

  }



  return (

    <Box

      sx={{

        display: "flex",

        flexDirection: "column",

        width: "100%",

        maxWidth: "100vw",

        px: { xs: 0, md: 2.5 },

        py: { xs: 0, md: 4 },

        pb: 0,

        mr: { xs: -6 },

        pr: { xs: 0 },

      }}

    >

      {/* Cabecera fija */}

      <Box

        sx={{

          display: "flex",

          flexDirection: "column",

          width: "100%",

          position: "fixed",

          top: 0,

          left: 0,

          right: 0,

          padding: { xs: "12px 16px", sm: "8px 16px", md: "12px 16px" },

          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",

          backgroundColor: "white",

          zIndex: 1000,

        }}

      >

      <Box 

        sx={{

          display: "flex",

          alignItems: "center",

          gap: 2,

          mb: 0,

          padding: 0,

        }}

      >

        <Button

          startIcon={<ArrowBackIcon />}

          onClick={() => navigate('/dashboard/analizador')}

          variant="text"

          sx={{ minWidth: "auto" }}

        >

          {t('Volver')}

        </Button>

        

        {/* Solo ícono en móvil */}

        <Box sx={{ display: { xs: "flex", sm: "none" }, alignItems: "center" }}>

          <IconButton

            onClick={() => navigate('/dashboard/analizador')}

            sx={{

              color: "#0F52BD",

              backgroundColor: "transparent",

              borderRadius: "8px",

              "&:hover": { backgroundColor: "#E3F2FD" },

              width: 40,

              height: 40,

            }}

          >

            <AddCircleOutlineIcon sx={{ fontSize: "28px" }} />

          </IconButton>

        </Box>

        

        {/* Texto en tablet/desktop */}

        <Box sx={{ display: { xs: "none", sm: "flex" }, alignItems: "center" }}>

          <Typography 

            variant="h4" 

            component="h1" 

            sx={{

              fontSize: { sm: "18px", md: "16px", lg: "22px" },

              fontWeight: "medium",

            }}

          >

            {t('Nuevo Análisis de Accesibilidad')}

          </Typography>

        </Box>

      </Box>

      </Box>



      {/* Spacer para empujar el contenido hacia abajo */}

      <Box

        sx={{

          height: { xs: "65px", sm: "70px", md: "100px", lg: "90px" },

          "@media (max-width: 600px) and (min-resolution: 1.25dppx)": {

            height: "65px",

          },

          "@media (max-width: 600px) and (min-resolution: 1.5dppx)": {

            height: "90px",

          },

          "@media (min-width: 600px) and (min-resolution: 1.25dppx)": {

            height: "75px",

          },

          "@media (min-width: 900px) and (min-resolution: 1.25dppx)": {

            height: "95px",

          },

        }}

      />



      <Box

        sx={{

          ml: { xs: -6, md: 0 },

          paddingLeft: { xs: 6, md: 2 },

          paddingRight: { xs: 0, md: 4 },

          pt: { xs: 2, md: 2 },

        }}

      >

      <Grid container spacing={3}>

        {/* Main Form */}

        <Grid item xs={12} md={8}>

          <Paper elevation={1} sx={{ p: 3 }}>

            <Stepper activeStep={activeStep} orientation="vertical">

              <Step>

                <StepLabel icon={steps[0].icon}>

                  {steps[0].label}

                </StepLabel>

                <StepContent>

                  <Stack spacing={3}>

                    <Box>

                      <Typography variant="h6" gutterBottom>

                        {t('URL del sitio web')}

                      </Typography>

                      <TextField

                        fullWidth

                        label={t('Ingresa la URL a analizar')}

                        value={url}

                        onChange={(e) => setUrl(e.target.value)}

                        placeholder="https://ejemplo.com"

                        variant="outlined"

                        disabled={loading}

                        error={!!error && !url}

                        helperText={error && !url ? error : t('Ejemplo: https://www.tusitio.com')}

                        InputProps={{

                          startAdornment: <LanguageIcon sx={{ mr: 1, color: 'text.secondary' }} />,

                        }}

                      />

                    </Box>



                    <Box>

                      <Typography variant="h6" gutterBottom>

                        {t('Opciones avanzadas')}

                      </Typography>

                      

                      <Stack spacing={2}>

                        <TextField

                          select

                          label={t('Nivel WCAG')}

                          value={analysisOptions.standard}

                          onChange={(e) => setAnalysisOptions({

                            ...analysisOptions,

                            standard: e.target.value

                          })}

                          disabled={loading}

                          size="small"

                          sx={{ maxWidth: 250 }}

                          SelectProps={{ native: true }}

                        >

                          <option value="WCAG2A">WCAG 2.1 Level A</option>

                          <option value="WCAG2AA">WCAG 2.1 Level AA</option>

                          <option value="WCAG2AAA">WCAG 2.1 Level AAA</option>

                        </TextField>



                        <TextField

                          select

                          label={t('Tamaño de viewport')}

                          value={`${analysisOptions.viewport.width}x${analysisOptions.viewport.height}`}

                          onChange={(e) => {

                            const [width, height] = e.target.value.split('x').map(Number);

                            setAnalysisOptions({

                              ...analysisOptions,

                              viewport: { width, height }

                            });

                          }}

                          disabled={loading}

                          size="small"

                          sx={{ maxWidth: 250 }}

                          SelectProps={{ native: true }}

                        >

                          <option value="375x667">Mobile (375x667)</option>

                          <option value="768x1024">Tablet (768x1024)</option>

                          <option value="1366x768">Desktop (1366x768)</option>

                          <option value="1920x1080">Full HD (1920x1080)</option>

                        </TextField>



                        <Box>

                          <Typography variant="body2" sx={{ mb: 1, color: '#666' }}>

                            {t('Niveles de impacto a incluir')}:

                          </Typography>

                          <Stack direction="row" spacing={1} flexWrap="wrap">

                            {['critical', 'serious', 'moderate', 'minor'].map((impact) => (

                              <FormControlLabel

                                key={impact}

                                control={

                                  <Checkbox

                                    size="small"

                                    checked={analysisOptions.includedImpacts.includes(impact)}

                                    onChange={(e) => {

                                      if (e.target.checked) {

                                        setAnalysisOptions({

                                          ...analysisOptions,

                                          includedImpacts: [...analysisOptions.includedImpacts, impact]

                                        });

                                      } else {

                                        setAnalysisOptions({

                                          ...analysisOptions,

                                          includedImpacts: analysisOptions.includedImpacts.filter(i => i !== impact)

                                        });

                                      }

                                    }}

                                    disabled={loading}

                                  />

                                }

                                label={t(impact.charAt(0).toUpperCase() + impact.slice(1))}

                                sx={{ textTransform: 'capitalize' }}

                              />

                            ))}  

                          </Stack>

                        </Box>

                      </Stack>

                    </Box>



                    {error && (

                      <Alert severity="error">{error}</Alert>

                    )}



                    <Box display="flex" gap={2}>

                      <Button

                        variant="contained"

                        startIcon={<PlayArrowIcon />}

                        onClick={handleStartAnalysis}

                        disabled={loading || !url || !analyserService}

                        sx={{

                          backgroundColor: '#0F52BD',

                          '&:hover': { backgroundColor: '#0a3d8f' }

                        }}

                      >

                        {t('Iniciar Análisis')}

                      </Button>

                    </Box>

                  </Stack>

                </StepContent>

              </Step>



              <Step>

                <StepLabel icon={steps[1].icon}>

                  {steps[1].label}

                </StepLabel>

                <StepContent>

                  <Box textAlign="center" py={3}>

                    <CircularProgress size={60} />

                    <Typography variant="h6" mt={3}>

                      {t('Analizando accesibilidad...')}

                    </Typography>

                    <Typography variant="body2" color="text.secondary" mt={1}>

                      {t('Esto puede tomar unos momentos')}

                    </Typography>

                  </Box>

                </StepContent>

              </Step>



              <Step>

                <StepLabel icon={steps[2].icon}>

                  {steps[2].label}

                </StepLabel>

                <StepContent>

                  <Alert severity="success" icon={<CheckCircleIcon />}>

                    <Typography variant="h6">

                      {t('¡Análisis completado exitosamente!')}

                    </Typography>

                    <Typography variant="body2" mt={1}>

                      {t('Redirigiendo al reporte...')}

                    </Typography>

                  </Alert>

                </StepContent>

              </Step>

            </Stepper>

          </Paper>

        </Grid>



        {/* Info Panel */}

        <Grid item xs={12} md={4}>

          <Card elevation={1}>

            <CardContent>

              <Typography variant="h6" gutterBottom display="flex" alignItems="center" gap={1}>

                <InfoIcon color="primary" />

                {t('¿Qué analizamos?')}

              </Typography>

              <Divider sx={{ my: 2 }} />

              

              <List dense>

                <ListItem>

                  <ListItemIcon>

                    <AccessibilityIcon fontSize="small" />

                  </ListItemIcon>

                  <ListItemText

                    primary={t('Cumplimiento WCAG')}

                    secondary={t('Verificamos el cumplimiento con las pautas WCAG 2.1')}

                  />

                </ListItem>

                <ListItem>

                  <ListItemIcon>

                    <CheckCircleIcon fontSize="small" />

                  </ListItemIcon>

                  <ListItemText

                    primary={t('Mejores prácticas')}

                    secondary={t('Evaluamos las mejores prácticas de accesibilidad web')}

                  />

                </ListItem>

                <ListItem>

                  <ListItemIcon>

                    <SpeedIcon fontSize="small" />

                  </ListItemIcon>

                  <ListItemText

                    primary={t('Análisis automático')}

                    secondary={t('Detección automática de problemas comunes')}

                  />

                </ListItem>

              </List>

            </CardContent>

          </Card>



          <Card elevation={1} sx={{ mt: 2 }}>

            <CardContent>

              <Typography variant="h6" gutterBottom>

                {t('Tiempo estimado')}

              </Typography>

              <Typography variant="body2" color="text.secondary">

                {t('El análisis generalmente toma entre 30 segundos y 2 minutos dependiendo del tamaño del sitio.')}

              </Typography>

            </CardContent>

          </Card>



          <Card elevation={1} sx={{ mt: 2 }}>

            <CardContent>

              <Typography variant="h6" gutterBottom>

                {t('Recomendaciones')}

              </Typography>

              <Typography variant="body2" color="text.secondary" paragraph>

                {t('Para mejores resultados, asegúrate de que:')}

              </Typography>

              <List dense>

                <ListItem>

                  <ListItemText

                    primary={`• ${t('El sitio web esté accesible públicamente')}`}

                  />

                </ListItem>

                <ListItem>

                  <ListItemText

                    primary={`• ${t('No requiera autenticación para las páginas principales')}`}

                  />

                </ListItem>

                <ListItem>

                  <ListItemText

                    primary={`• ${t('La URL sea correcta y completa')}`}

                  />

                </ListItem>

              </List>

            </CardContent>

          </Card>

        </Grid>

      </Grid>

      </Box>

      <Dialog open={contactDialogOpen} onClose={() => setContactDialogOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: 'medium', fontSize: '24px' }}>Contratar Analizador</DialogTitle>
        <DialogContent sx={{ padding: '25px' }}>
          <Typography sx={{ fontSize: '16px', color: '#4F4F4F' }}>
            Para contratar este servicio, por favor contacta con <strong>Inforges</strong>.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ paddingRight: '25px', paddingBottom: '25px' }}>
          <Button onClick={() => setContactDialogOpen(false)} variant="contained" sx={{ textTransform: 'none', fontSize: '16px' }}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

    </Box>

  );

};

export default NuevoAnalisis;
